import clsx from "clsx";
import type { ComponentProps } from "react";

import type { ListWithIconType } from "@features/article-content/model";

import { BrandIcon } from "@shared/ui/brand-icon";
import { Body, Heading } from "@shared/ui/typography";

import s from "./amenities-list.module.scss";

type AmenitiesListProps = ComponentProps<"div"> & ListWithIconType;

export const AmenitiesList = (props: AmenitiesListProps) => {
  const { className, title, icon, items } = props;

  return (
    <section className={clsx(s.root, className)}>
      <div className={s.header}>
        {title && (
          <Heading level={6} className={s.title}>
            {title}
          </Heading>
        )}
        {icon?.icon?.name && (
          <BrandIcon
            className={s.icon}
            name={icon.icon.name}
            fillColor={icon.fillColor}
            strokeColor={icon.strokeColor}
            svg_code={icon.uicon?.svg_code}
          />
        )}
      </div>
      {items?.length > 0 && (
        <Body tag="ul" className={s.list}>
          {items.map((item, idx) =>
            item?.text != null && item.text !== "" ? (
              <li key={item?.id ?? idx} className={s.item}>
                <Body>{item.text}</Body>
              </li>
            ) : null,
          )}
        </Body>
      )}
    </section>
  );
};

AmenitiesList.displayName = "AmenitiesList";
